




import enterpriseTemplate from "./templates/enterpriseTemplate.vue";
import businessTemplate from "./templates/businessTemplate.vue";
import doctorTemplate from "./templates/doctorTemplate.vue";
export default {
  name: "aiwen-register-pc",
  components: {
    enterpriseTemplate,
    businessTemplate,
    doctorTemplate,
  },
  computed: {
    currentComponent() {
      console.log((this as any).$attrs, "this.$attrs init");
      interface IbusinessTypeObj {
        [propName: string]: any;
      }
      const businessTypeObj: IbusinessTypeObj = {
        business: "businessTemplate",
        doctor: "doctorTemplate",
        biz: "enterpriseTemplate",
      };
      return businessTypeObj[(this as any).$attrs.config.businessType];
    },
  },
};
